<template>
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div> {{ showLoading ? waitText : ''}}
</template>

<script>
export default {
    name: "Loader",
    props: {
        showLoading: {
            type: Boolean,
            default: true
        },
        waitText: {
            type: String,
            default: 'Loading...'
        }
    }
}
</script>

<style scoped lang="scss">
@use "sass:math";

$scale: 2;
$color:#94c632;

.lds-ellipsis {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    width: math.div(80px, $scale);
    height: math.div(80px, $scale);
}
.lds-ellipsis div {
    position: absolute;
    top: math.div(33px, $scale);
    width: math.div(13px, $scale);
    height: math.div(13px, $scale);
    border-radius: 50%;
    background: $color;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: math.div(8px, $scale);
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: math.div(8px, $scale);
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: math.div(32px, $scale);
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: math.div(56px, $scale);
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(math.div(24px, $scale), 0);
    }
}

</style>